import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BookingsViewService } from '../../bookings-view/bookings-view.service';

@Component({
  selector: 'app-define-cabs-dialog',
  templateUrl: './define-cabs-dialog.component.html',
  styleUrls: ['./define-cabs-dialog.component.scss']
})
export class DefineCabsDialogComponent implements OnInit {
  cabsData: any;
  tempHighCapCabsData: any;
  isEdited: boolean = false;
  alteredList: any = [];

  @Output() highCapVehiclesConfigEmitter: EventEmitter<void> = new EventEmitter()

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<DefineCabsDialogComponent>,
    private bookingsViewService: BookingsViewService
  ) { }

  ngOnInit(): void {
    this.cabsData = this.data;
    this.tempHighCapCabsData = JSON.parse(JSON.stringify(this.data));
  }

  handleCheckboxClick(clickedItem: any) {
    const cabType = clickedItem.name;
    const foundCab = this.tempHighCapCabsData.find((cab: any)=> cab.cabType === clickedItem.name); 
    if(foundCab){
      foundCab.highCapacity = clickedItem.value;
    }
    this.checkForChanges()

    const index = this.alteredList.findIndex(element => element.cabType === cabType);
    if (index === -1) {
      this.alteredList.push({
        cabType,
        highCapacity: clickedItem.value
      });
    }
    else {
      this.alteredList[index].highCapacity = clickedItem.value;
    }
  }

  checkForChanges(){
    this.isEdited = this.cabsData.some((cab: any)=>{
      const foundCab = this.tempHighCapCabsData.find((tempCab: any)=> tempCab.cabType === cab.cabType); 
      return foundCab && foundCab.highCapacity !== cab.highCapacity;
    })
  }

  saveChanges(){
    if(this.alteredList.length){  
      this.bookingsViewService.updateHighCapVehicle(this.alteredList).subscribe((res)=>{
        if(res?.toLowerCase()==='request submitted successfully'){
          this.highCapVehiclesConfigEmitter.emit()
        }
      });
    }    
    this.dialogRef.close();
  }
}
